export default __webpack_public_path__ + "static/media/gallery-s-2.bb9daf6c.png";